import React from "react";
import { ProductCardBlockStyle } from "./ProductCardBlockStyle";
import { ProductCardListStyle } from "./ProductCardListStyle";

export class ProductCard extends React.Component<any, any> {

	constructor(props:any) {
		super(props);
	}

	render(): React.ReactNode {
		const product_card_settings = {
			data: this.props.data			
		}

		return (
			<>
				{(this.props.layout === 'block-type') ?
				<ProductCardBlockStyle  {...product_card_settings}/>
				: <ProductCardListStyle {...product_card_settings} />}
			</>
		);
	}	
}